import {Provider} from '@angular/core';
import {ENVIRONMENT_TOKEN} from '../environments/environment.interface';
import {environment} from '../environments/environment';

export const provideEnv: Provider = {
  provide: ENVIRONMENT_TOKEN,
  useValue: environment
}
